import {
  CopyOutlined,
  PlusOutlined,
  SaveOutlined,
  SendOutlined,
} from '@ant-design/icons';
import {
  Alert,
  Button,
  Col,
  Divider,
  Drawer,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
} from 'antd';
import _ from 'lodash';
import React, { useMemo, useRef, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FETCH_STATUS_ENUM, OPENAI_PROMPTS } from '../../../enums/enums';
import {
  baseCompletionPayload,
  createCompletion,
} from '../services/openai-service';
let index = 0;

function GenieDrawerComponent({ onClose, open }) {
  const [genieSuggestion, setGenieSuggestion] = useState('');
  const [genieFetchStatus, setGenieFetchStatus] = useState('');
  const [copied, setCopied] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [form] = Form.useForm();
  const getItems = () => {
    const itms = [];
    _.values(OPENAI_PROMPTS).forEach((op) => {
      const item = { label: op.title, value: op.key };
      itms.push(item);
    });
    return itms;
  };
  const items = useMemo(() => getItems(), [OPENAI_PROMPTS]);
  // const [items, setItems] = useState(getItems);

  const onFinish = async (values) => {
    if (values?.data?.length > 0) {
      const found = _.find(
        OPENAI_PROMPTS,
        (op) => op.key === values.prompt.value
      );
      if (found) {
        setGenieFetchStatus(FETCH_STATUS_ENUM.LOADING.status);
        const payload = await baseCompletionPayload();
        payload.prompt = `${found.prompt}${values.data}`;

        await createCompletion(payload)
          .then((response) => {
            const { data } = response;
            if (data.choices && data.choices.length > 0) {
              setGenieSuggestion(data.choices[0].text);
            }
            setGenieFetchStatus(FETCH_STATUS_ENUM.SUCCESS.status);
          })
          .catch((error) => {
            setGenieSuggestion(
              'Oops, something went wrong. Please try again later'
            );
            console.error(error);
            setGenieFetchStatus(FETCH_STATUS_ENUM.FAILED.status);
          })
          .finally(() => {
            setGenieFetchStatus(FETCH_STATUS_ENUM.SUCCESS.status);
          });
      }
    }
  };
  const onPromptChange = (value, option) => {
    form.setFieldValue('prompt', option);
  };

  const getFormattedGenieSuggestion = () => {
    if (genieSuggestion.length > 0) {
      return _.split(genieSuggestion, '\n').map((item, idx) => {
        return item.length > 0 ? (
          <Col key={idx} span={24}>
            {item}
          </Col>
        ) : (
          ''
        );
      });
    }
  };
  const formattedGenieSuggestion = useMemo(
    () => getFormattedGenieSuggestion(),
    [genieSuggestion]
  );
  return (
    <Drawer
      title="How can I help you?"
      placement="top"
      height={750}
      onClose={onClose}
      open={open}
      closable={false}
      extra={
        <Space>
          {contextHolder}
          <Button type="primary" onClick={onClose}>
            Close Genie
          </Button>
        </Space>
      }
    >
      {' '}
      <Form
        colon={false}
        form={form}
        layout="vertical"
        name="openai-form"
        //   labelCol={{ span: 10 }}
        //   wrapperCol={{ span: 16 }}
        initialValues={{}}
        onFinish={onFinish}
      >
        <Row gutter={[24, 24]}>
          <Col span={8}>
            <Form.Item
              name="prompt"
              label="What would you like me to do?"
              rules={[
                {
                  required: true,
                  message: "Please select what you'd like me to do",
                },
              ]}
            >
              <Select
                style={{ width: 300 }}
                placeholder="Make a selection..."
                onChange={onPromptChange}
                options={items}
              />
            </Form.Item>
          </Col>
          <Col span={16}></Col>
          <Col span={12}>
            <Form.Item
              label="Enter data"
              name="data"
              rules={[
                {
                  required: true,
                  message: 'Please provide me with some data to work on',
                },
              ]}
            >
              <Input.TextArea
                showCount
                allowClear
                style={{ width: '100%' }}
                placeholder="eg. Product details"
                autoSize={{ minRows: 17, maxRows: 17 }}
              ></Input.TextArea>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Spin
              spinning={FETCH_STATUS_ENUM.LOADING.status === genieFetchStatus}
            >
                {/* <Row>
                  <Col span={24}>
                    {copied && <Alert message="Genie suggestion copied to clipboard" type="success" closable afterClose={()=>setCopied(false)} />}
                  </Col>
                </Row> */}
                <Row>
                  <Col span={24}>
                    <Divider orientation="left">
                      <Space>
                        <span>Genie Suggestion </span>
                        <CopyToClipboard text={genieSuggestion}  onCopy={()=> messageApi.info('Genie suggestion copied to clipboard')}>
                          <Button icon={<CopyOutlined />} type="text"/>
                        </CopyToClipboard>
                       
                      </Space>
                    </Divider>
                  </Col>
                </Row>
                <Row style={{ overflowY: 'scroll' }}>{formattedGenieSuggestion}</Row>
            </Spin>
          </Col>
          <Col span={24}>
            <Button
              type="primary"
              htmlType="submit"
              icon={<SendOutlined />}
              ghost
              disabled={FETCH_STATUS_ENUM.LOADING.status === genieFetchStatus}
            >
              Generate
            </Button>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
}

export default GenieDrawerComponent;
